import { getConstants } from "@utilifiles/methods/storage/storage"
import instance from "@services/services"
import api from "@services/apiList"
import { ResponseType } from "../../../Types/ServicesType/servicesType"
import { MasterDataType, MasterTableDataType, SearchParamsType } from "./types"
const { clinicId, createdById } = getConstants()
const {MastersApi} = api
export const getAllMasterData = async (params:SearchParamsType):Promise<ResponseType<{items:MasterTableDataType[],totalRecords:number}>>=>{
    const result = await instance.post(MastersApi.getAllClinician,{...params,clinicId})
    return result.data
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<string>>=>{
    const result = await instance.post(MastersApi.saveClinician,params)
    return result.data
}

export const uploadFile = async (file:File):Promise<ResponseType<string>>=>{
    const formData = new FormData();
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    formData.append("file", file);
    const result = await instance.post(`${MastersApi.uploadClinicanExcel}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return result.data;
}

export const getAllMinistry = async ():Promise<ResponseType<{id:number,ministryName:string}[]>>=>{
    const result = await instance.get(MastersApi.getAllMinistry)
    return result.data
}

export const getAllEmployee = async (searchText:string):Promise<ResponseType<{empId:number,empName:string}[]>>=>{
    const result = await instance.post(MastersApi.getEmployee,{searchText,clinicId})
    return result.data
}